module.exports = __webpack_public_path__ + "1c0daf089a9769b6ea09786ecdf46cb9.jpg";